/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

// import 'bootstrap/dist/css/bootstrap.min.css'
import './src/assets/main.scss';

import React from 'react';
import CountryRedirect from './src/components/CountryRedirect';
import { persistUtmParams } from './src/helpers/utmAttribution';

export const wrapRootElement = ({ element }) => (
  <CountryRedirect>{element}</CountryRedirect>
);

/**
 * Capture ad attribution at first touch and keep it for 15 days.
 *
 * Fires on the initial load and on every client-side route change, and no-ops
 * when the URL carries no parameters — so an internal navigation can never
 * clear an earlier capture. Without this, attribution lived only in
 * `window.location.search` and was lost the moment the visitor clicked
 * anything.
 */
export const onRouteUpdate = () => {
  persistUtmParams();
};
